var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",style:({
    width: _vm.pageWidth
  }),on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"header",style:({
      marginLeft: _vm.halfOfmarginH,
      marginRight: _vm.halfOfmarginH,
    })},[_vm._t("header")],2),(!_vm.hidePrimaryMain)?_c('div',{staticClass:"primary",class:{'non-header-content': _vm.onlyHeader},style:({
      marginLeft: _vm.halfOfmarginH,
      marginRight: _vm.halfOfmarginH
    })},[_c('div',{ref:"primaryMain",staticClass:"primary-main",style:({
        width: _vm.primaryMainWidth
      })},[_vm._t("primary-main")],2),(_vm.showPrimaryRelated)?_c('div',{ref:"primaryRelated",staticClass:"primary-related",style:({
        width: _vm.primaryRelatedWidthC
      })},[_vm._t("primary-related")],2):_vm._e()]):_vm._e(),_c('div',{staticClass:"secondary-1",class:{'non-header-content': _vm.onlyHeader},style:({
      marginLeft: _vm.halfOfmarginH,
      marginRight: _vm.halfOfmarginH
    })},[_vm._t("secondary-1")],2),_c('div',{staticClass:"secondary-2",class:{'non-header-content': _vm.onlyHeader}},[_vm._t("secondary-2")],2),_c('div',{staticClass:"secondary-3",class:{'non-header-content': _vm.onlyHeader},style:({
      marginLeft: _vm.halfOfmarginH,
      marginRight: _vm.halfOfmarginH
    })},[_vm._t("secondary-3")],2),_c('div',{staticClass:"secondary-4",class:{'non-header-content': _vm.onlyHeader},style:({
      marginLeft: _vm.halfOfmarginH,
      marginRight: _vm.halfOfmarginH
    })},[_vm._t("secondary-4")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }